import type { AxiosResponse } from 'axios';
import axios from 'axios';
import type { ReactNode } from 'react';

import { createErrorToast } from '@adflow/frontend/ui-toasts';

/**
 * Attempt to get a request id from an error. Returns `null` when a request id is not found.
 */
function getRequestId(response: AxiosResponse | undefined): string | null {
	const requestId = response?.headers?.['x-request-id'];

	if (typeof requestId === 'string') {
		return requestId;
	}

	return null;
}

interface HandleRequestErrorsOptions {
	errorMessage: ReactNode;
}

/**
 * Global handler for errors returned from external requests.
 * Currently:
 *  - Shows error toast
 *  - Shows error in console
 */
export function handleRequestErrors(
	errors: unknown[],
	options: Pick<HandleRequestErrorsOptions, 'errorMessage'>
) {
	const requestIds = errors
		.filter(axios.isAxiosError)
		.map((e) => getRequestId(e.response))
		.filter((id): id is string => id !== null);

	createErrorToast(options.errorMessage, { errorCodes: requestIds });

	for (const err of errors) {
		console.error(options.errorMessage, err);
	}
}
